module.exports = __webpack_public_path__ + "e166f915608298779fe4acc740489526.svg";